import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Clock,
  User,
  ChevronDown,
  ChevronUp,
  Eye,
  Layers,
  Shirt
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4} />
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// SpecBlock â€” collapsible object with key/value pairs
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SpecBlock = ({ icon: Icon, title, data = {}, colorClass, bgClass, borderClass, defaultOpen = false }) => {
  const [expanded, setExpanded] = useState(defaultOpen);
  if (!data || !Object.keys(data).length) return null;

  return (
    <div className={`rounded-lg border ${borderClass} overflow-hidden`}>
      <button onClick={() => setExpanded(!expanded)}
        className={`w-full flex items-center justify-between p-3 ${bgClass} hover:opacity-90 transition-opacity`}>
        <div className="flex items-center gap-2">
          <Icon className={`w-4 h-4 ${colorClass}`} />
          <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
        </div>
        {expanded
          ? <ChevronUp className={`w-4 h-4 ${colorClass} opacity-50`} />
          : <ChevronDown className={`w-4 h-4 ${colorClass} opacity-50`} />}
      </button>
      {expanded && (
        <div className="bg-white p-4 space-y-3 border-t border-gray-100">
          {Object.entries(data).map(([key, value]) => {
            if (value === null || value === undefined || value === '') return null;
            return (
              <div key={key}>
                <p className="text-xs font-medium text-gray-500 capitalize mb-0.5">
                  {key.replace(/_/g, ' ')}
                </p>
                {Array.isArray(value) ? (
                  <ul className="space-y-1 ml-1">
                    {value.map((item, i) => (
                      <li key={i} className="flex items-start gap-1.5 text-sm text-gray-700">
                        <span className={`${colorClass} mt-0.5 opacity-60 font-bold`}>·</span>
                        {typeof item === 'string' ? item : JSON.stringify(item)}
                      </li>
                    ))}
                  </ul>
                ) : typeof value === 'object' ? (
                  <div className="ml-2 space-y-1">
                    {Object.entries(value).map(([k, v]) => (
                      <div key={k} className="text-sm text-gray-700">
                        <span className="text-gray-400 capitalize">{k.replace(/_/g, ' ')}: </span>
                        {String(v)}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-800">{String(value)}</p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// RulesList
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const RulesList = ({ icon: Icon, title, items = [], colorClass, bgClass, borderClass }) => {
  if (!items.length) return null;
  return (
    <div className={`rounded-lg border ${borderClass} overflow-hidden`}>
      <div className={`flex items-center gap-2 p-3 ${bgClass}`}>
        <Icon className={`w-4 h-4 ${colorClass}`} />
        <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
        <span className="ml-auto text-xs text-gray-400">{items.length} items</span>
      </div>
      <ul className="divide-y divide-gray-100 bg-white">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3 p-3">
            <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full text-xs font-bold ${colorClass} bg-gray-50 border border-current`}>
              {i + 1}
            </span>
            <p className="text-sm text-gray-700 leading-relaxed">{typeof item === "string" ? item : JSON.stringify(item)}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// IdentityHeader â€” archetype + top-level fields
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const IdentityHeader = ({ spec = {}, archetype }) => (
  <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 space-y-3">
    {archetype && (
      <div>
        <p className="text-xs font-medium text-purple-500 uppercase tracking-wide mb-1">Model Archetype</p>
        <p className="text-sm font-semibold text-purple-800 leading-relaxed">{archetype}</p>
      </div>
    )}
    <div className="flex flex-wrap gap-3">
      {[
        { key: 'identity_type',                   label: 'Identity Type' },
        { key: 'age_range',                        label: 'Age Range' },
        { key: 'gender',                           label: 'Gender' },
        { key: 'nationality_or_cultural_context',  label: 'Cultural Context' },
        { key: 'ethnicity_or_appearance_context',  label: 'Appearance Context' },
      ].map(({ key, label }) =>
        spec[key] ? (
          <div key={key} className="bg-white border border-purple-100 rounded-lg px-3 py-2">
            <p className="text-xs text-purple-400">{label}</p>
            <p className="text-sm font-medium text-purple-800">{typeof spec[key] === "string" ? spec[key] : JSON.stringify(spec[key])}</p>
          </div>
        ) : null
      )}
    </div>
  </div>
);

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// EmptyState
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const EmptyState = () => (
  <div className="flex items-center justify-center h-full">
    <div className="text-center text-gray-500">
      <Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" />
      <p className="text-lg font-medium mb-2">In attesa di esecuzione</p>
      <p className="text-sm">Clicca "Esegui Contract" per avviare l'Avatar Identity Layer Engine</p>
    </div>
  </div>
);

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract13View
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const Contract13View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution) return <EmptyState />;

  const output = execution.output || execution.outputData || {};
  const {
    avatar_specification = {},
    model_archetype = '',
    visual_identity = {},
    wardrobe_rules = []
  } = output;

  const specSections = [
    {
      key: 'face_specification',
      title: 'Face Specification',
      icon: User,
      color: 'text-purple-700', bg: 'bg-purple-50', border: 'border-purple-200',
      open: true
    },
    {
      key: 'body_specification',
      title: 'Body Specification',
      icon: User,
      color: 'text-violet-700', bg: 'bg-violet-50', border: 'border-violet-200'
    },
    {
      key: 'hair_specification',
      title: 'Hair Specification',
      icon: User,
      color: 'text-indigo-700', bg: 'bg-indigo-50', border: 'border-indigo-200'
    },
    {
      key: 'skin_texture_specification',
      title: 'Skin Texture Specification',
      icon: Layers,
      color: 'text-fuchsia-700', bg: 'bg-fuchsia-50', border: 'border-fuchsia-200'
    },
  ];

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="max-w-4xl mx-auto space-y-6">

        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-1">
            <User className="w-6 h-6 text-purple-600" />
            <h2 className="text-xl font-bold text-gray-800">Avatar Identity</h2>
            <span className="px-2 py-0.5 text-xs bg-purple-100 text-purple-700 rounded-full font-medium">C13</span>
          </div>
          <p className="text-sm text-gray-500">
            Identity Layer â€” identitÃ  persistente e riutilizzabile. Solo aspetto statico.
          </p>
        </div>

        {/* Identity header */}
        <IdentityHeader spec={avatar_specification} archetype={model_archetype} />

        {/* Spec sub-sections */}
        <div className="space-y-3">
          {specSections.map(({ key, title, icon, color, bg, border, open }) => (
            <SpecBlock
              key={key}
              icon={icon}
              title={title}
              data={avatar_specification[key]}
              colorClass={color}
              bgClass={bg}
              borderClass={border}
              defaultOpen={!!open}
            />
          ))}
        </div>

        {/* Persistent visual markers & consistency rules */}
        <div className="space-y-3">
          <RulesList
            icon={Eye}
            title="Persistent Visual Markers"
            items={avatar_specification.persistent_visual_markers || []}
            colorClass="text-purple-700"
            bgClass="bg-purple-50"
            borderClass="border-purple-200"
          />
          <RulesList
            icon={Layers}
            title="Identity Consistency Rules"
            items={avatar_specification.identity_consistency_rules || []}
            colorClass="text-violet-700"
            bgClass="bg-violet-50"
            borderClass="border-violet-200"
          />
        </div>

        {/* Visual Identity */}
        {Object.keys(visual_identity).length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Eye className="w-4 h-4 text-indigo-600" />
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Visual Identity</h3>
            </div>
            <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 space-y-3">
              {visual_identity.overall_look && (
                <div>
                  <p className="text-xs font-medium text-indigo-500 mb-0.5">Overall Look</p>
                  <p className="text-sm text-indigo-800">{visual_identity.overall_look}</p>
                </div>
              )}
              <div className="flex flex-wrap gap-3">
                {visual_identity.attractiveness_level && (
                  <div className="bg-white border border-indigo-100 rounded-lg px-3 py-2">
                    <p className="text-xs text-indigo-400">Attractiveness Level</p>
                    <p className="text-sm font-medium text-indigo-800">{visual_identity.attractiveness_level}</p>
                  </div>
                )}
                {visual_identity.styling_level && (
                  <div className="bg-white border border-indigo-100 rounded-lg px-3 py-2">
                    <p className="text-xs text-indigo-400">Styling Level</p>
                    <p className="text-sm font-medium text-indigo-800">{visual_identity.styling_level}</p>
                  </div>
                )}
              </div>
              <RulesList
                icon={Eye}
                title="Beauty Optimization Limits"
                items={visual_identity.beauty_optimization_limits || []}
                colorClass="text-indigo-700"
                bgClass="bg-indigo-50"
                borderClass="border-indigo-200"
              />
              <RulesList
                icon={CheckCircle2}
                title="Visual Authenticity Rules"
                items={visual_identity.visual_authenticity_rules || []}
                colorClass="text-teal-700"
                bgClass="bg-teal-50"
                borderClass="border-teal-200"
              />
            </div>
          </div>
        )}

        {/* Wardrobe Rules */}
        <RulesList
          icon={Shirt}
          title="Wardrobe Rules"
          items={wardrobe_rules}
          colorClass="text-rose-700"
          bgClass="bg-rose-50"
          borderClass="border-rose-200"
        />

        {/* Review Gate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />

      </div>
    </div>
  );
};

export default Contract13View;

